export const eventFilters = () => {
    const $ = jQuery;
    let currentRequest = null;
    const postsWrapper = $('#posts-wrapper');
    const archiveFilters = $('#archive-filters');
    const timeframeRadios = $('input[name="timeframe"]');

    if(!$('.events-archive-alternative').length) return;

    const updateContent = (data) => {
        if (currentRequest) {
            currentRequest.abort();
        }

        postsWrapper.addClass('is-loading');

        currentRequest = $.ajax({
            url: wpApiSettings.root + 'ans/v1/events',
            method: 'GET',
            data,
            success: response => {
                if (response.html) {
                    postsWrapper.html(response.html);
                    updateLoadMoreButton(data.taxonomy_filters, response.more_posts);
                }
            },
            error: (xhr) => {
                if (xhr.status === 404) {
                    postsWrapper.html('<div class="no-results">No events found matching your criteria</div>');
                    $('#load-more-events').attr('disabled', 'true');
                } else {
                    postsWrapper.html('<div class="error">Error loading events</div>');
                }
            }
        }).always(() => {
            postsWrapper.removeClass('is-loading');
            //$('#archive-featured').hide();
        });
    };

    const getFilterState = () => {
        const filters = {};

        archiveFilters.find('.filter-input:checked').each(function() {
            const name = $(this).attr('name').replace('[]', '');
            // Map 'solution' to 'category'
            const taxonomyName = name === 'solution' ? 'category' : name;
            if (!filters[taxonomyName]) filters[taxonomyName] = new Set();
            filters[taxonomyName].add($(this).val());
        });

        return Object.fromEntries(
            Object.entries(filters).map(([key, values]) => [key, Array.from(values)])
        );
    };

    const setFilterState = (state) => {
        archiveFilters.find('.filter-input').prop('checked', false);
        Object.entries(state).forEach(([taxonomy, terms]) => {
            // Map 'category' back to 'solution' for DOM lookups
            const domTaxonomy = taxonomy === 'category' ? 'solution' : taxonomy;
            terms.forEach(term => {
                archiveFilters.find(`#${domTaxonomy}-${term}`).prop('checked', true);
            });
        });
    };

    const parseUrlParams = () => {
        const params = new URLSearchParams(window.location.search);
        const state = {};

        for (const [key, value] of params) {
            state[key] = value.split(',');
        }

        return state;
    };

    const updateLoadMoreButton = (filters, hasMore) => {
        const button = $('#load-more-events');
        if (button.length) {
            Object.entries(filters).forEach(([taxonomy, terms]) => {
                button.attr(`data-${taxonomy}`, JSON.stringify(terms));
            });

            if(typeof hasMore !== 'undefined') {
                button.attr('disabled', !hasMore);
            }
        }
    };

    archiveFilters.find('.filter-input').on('change', function() {
        const filters = getFilterState();
        const urlParams = Object.entries(filters)
            .map(([key, values]) => `${key}=${values.join(',')}`)
            .join('&');

        history.pushState(filters, '', urlParams ? `?${urlParams}` : window.location.pathname);
        updateContent({ taxonomy_filters: filters });
    });

    $(window).on('popstate', function(e) {
        const state = e.originalEvent.state || {};
        setFilterState(state);
        updateLoadMoreButton(state);
        updateContent({ taxonomy_filters: state });
    });

    // Handle initial load
    const initialState = parseUrlParams();
    if (Object.keys(initialState).length) {
        setFilterState(initialState);
        updateLoadMoreButton(initialState);
        updateContent({ taxonomy_filters: initialState });
    }

    archiveFilters.find('.select-all').on('click', function(e) {
        e.preventDefault();
        const wrapper = $(this).closest('.filter-wrapper');
        wrapper.find('.filter-input[type="checkbox"]').prop('checked', true).first().trigger('change');
    });

    archiveFilters.find('.clear-all').on('click', function(e) {
        e.preventDefault();
        const wrapper = $(this).closest('.filter-wrapper');
        wrapper.find('.filter-input[type="checkbox"]').prop('checked', false).first().trigger('change');
    });

    // Show/hide filter actions
    archiveFilters.find('.filter-wrapper').each(function() {
        const wrapper = $(this);
        if (wrapper.find('.filter-input[type="checkbox"]').length > 0) {
            wrapper.find('.filter-actions').show();
        }
    });

    //Activate first radio if no timeframe is set.
    // if (timeframeRadios.length && !timeframeRadios.filter(':checked').length) {
    //     timeframeRadios.first().prop('checked', true).trigger('change');
    // }

};